
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TimelineEventList',
  props: {
    missionList: {
      type: Array,
      default: () => [],
    },
  },
})
